import * as hoem from './home'



export default {
    ...hoem
}
